import { Header, renderServiceTabs, AppVersionFooter, FloatingNav, BackToTopButton, initBackToTop } from '../../components';
import { getCurrentLanguage, t } from '../../i18n';
import { renderRoomServicePage, initRoomServicePage } from '../../pages/room-service';
import type { MiniAppService } from '@revio/shared';

export function renderServiceTicketEngine(service: MiniAppService): string {
  const lang = getCurrentLanguage();
  const serviceId = service?.id || 'service-ticket';
  const svcTitle = typeof service?.label === 'object'
    ? (service.label[lang] || service.label.en || service.label.th)
    : (service?.label || t('roomServiceTitle'));

  const bodyHtml = renderRoomServicePage();

  return `
    ${renderServiceTabs('service', serviceId)}
    <div class="page-container" id="ticket-engine-content" style="padding-bottom:100px;">
      ${bodyHtml}
    </div>
    ${BackToTopButton('ticket')}
    ${FloatingNav()}
  `;
}

export function initServiceTicketEngine(service: MiniAppService): void {
  const serviceId = service?.id || 'service-ticket';
  initRoomServicePage();
  initBackToTop('ticket');
}
